import React from 'react'

const Blob = () => {
  return (
    <div className="bg">
      <img src="/otherImages/bg.gif" alt="" />
    </div>
  )
}

export default Blob
